module.exports = __webpack_public_path__ + "static/img/normal.b4ff1be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f1/normal.png
// module id = yCEA
// module chunks = 0